/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  root: 'root_e3491856',
  item: 'item_e3491856',
};

export = styles;

loadStyles([{"rawString":".root_e3491856{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.item_e3491856{-ms-flex-negative:0;flex-shrink:0}"}]);
/* tslint:enable */